import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import JSONEditor from "../../components/JSONEditor/JSONEditor";
import { SMSCommand as SMSCommandType } from "./smsTypes";

const useStyles = makeStyles(() => ({
  editor: {
    margin: 0,
    marginTop: 20,
  },
  title: {
    marginBottom: "4px",
  },
}));

type SMSCommandEditorProps = {
  SMSCommand: SMSCommandType;
  onSMSCommandChanged: (json: any) => void;
};

const SMSCommandEditor: React.FC<SMSCommandEditorProps> = ({
  SMSCommand,
  onSMSCommandChanged = () => {},
}) => {
  const classes = useStyles();

  const jsonChanged = (json: string) => {
    try {
      JSON.parse(json);
    } catch (e) {
      return;
    }
    const { name, command, ignition_on, bulk_execution_enabled, companies } =
      JSON.parse(json);
    onSMSCommandChanged({
      name,
      command,
      ignition_on,
      bulk_execution_enabled,
      companies,
    });
  };

  return (
    <JSONEditor
      value={SMSCommand}
      width="100%"
      jsonChanged={jsonChanged}
      className={classes.editor}
      customTitle={
        <Typography variant="subtitle1" className={classes.title}>
          SMS Command JSON
        </Typography>
      }
    />
  );
};

export default SMSCommandEditor;
